module.exports = __webpack_public_path__ + "static/media/controlled-chair.36a99351.webp";